export default function checkDeviceType() {
  return (('ontouchstart' in window)
  || (navigator.maxTouchPoints > 0)
  || (navigator.msMaxTouchPoints > 0) ? 'mobile' : 'desktop');
}
